import { render, staticRenderFns } from "./CoinDetail.vue?vue&type=template&id=9444db6c&scoped=true&"
import script from "./CoinDetail.vue?vue&type=script&lang=js&"
export * from "./CoinDetail.vue?vue&type=script&lang=js&"
import style0 from "./CoinDetail.vue?vue&type=style&index=0&id=9444db6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9444db6c",
  null
  
)

export default component.exports